// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_b","title":"ac"};